import React, { useState, useEffect } from 'react';
import { VideoPlayer } from './components/VideoPlayer';
import { ChannelOverlay } from './components/ChannelOverlay';
import { Channel } from './types';
import { channels } from './data/channels';
import { LandingHero } from './components/LandingHero';

export default function App() {
  const [selectedChannel, setSelectedChannel] = useState<Channel | null>(null);
  const [showChannels, setShowChannels] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const streamParam = params.get('stream');

    if (streamParam === '') {
      setSelectedChannel(channels[0]);
    } else if (streamParam) {
      const channel = channels.find(ch => ch.stream === streamParam);
      if (channel) {
        setSelectedChannel(channel);
      }
    }
  }, []);

  const handleHomeClick = () => {
    setSelectedChannel(null);
    setShowChannels(false);
    window.history.pushState({}, '', window.location.pathname);
  };

  const handleSelectChannel = (channel: Channel) => {
    setSelectedChannel(channel);
    setShowChannels(false);
    window.history.pushState({}, '', `?stream=${channel.stream}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-950 via-purple-950 to-slate-950">
      <main className="relative h-screen">
        {selectedChannel ? (
          <div className="h-full">
            <VideoPlayer
              channel={selectedChannel}
              channels={channels}
              onSelectChannel={handleSelectChannel}
              onHomeClick={handleHomeClick}
            />
          </div>
        ) : (
          <LandingHero onWatchClick={() => setShowChannels(true)} />
        )}
      </main>

      <ChannelOverlay
        show={showChannels}
        onClose={() => setShowChannels(false)}
        channels={channels}
        selectedChannel={selectedChannel}
        onSelectChannel={handleSelectChannel}
      />
    </div>
  );
}